<template>
  <div id="summary-alt" class="panel active">
    <div class="panel-content px-xs-4 px-md-0 pt-xs-4 pt-md-80">
      <h1 v-html="$getString('GLOBAL_SIGNS_OF_A_MOTOR_DELAY')"></h1>
      <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
      <h2 class="mb-xs-4" v-html="$getString('SUMMARY_TAKE_THE_NEXT_STEP')"></h2>
      <p class="fg-sma-black-50 mb-xs-40" v-html="$getTemplatedString('SUMMARY_ALT_BASED_ON_YOUR_ANSWERS', { 'child_state': ageGroup.state })"></p>

      <div class="cta-row col-xs-12 mx-xl-auto mx-xs-0 px-xs-0">
        <div class="call-to-action">
          <span v-html="$getTemplatedString('SUMMARY_ALT_SPEAK_TO_DOCTOR', { 'child_state': ageGroup.state })"></span>
          <div class="clock scroll-on-show"></div>
        </div>
      </div>

      <div class="buttons my-xs-20">
        <div class="tool-button next" @click="onSave" v-html="$getString('GLOBAL_BUTTON_SAVE')"></div>
      </div>
      
      <div id="restart" class="restart-buttons container text-centered mt-xs-4">
        <div class="d-xs-inline-block fg-sma-fuchsia"><span class="icon icon-restart"></span>&nbsp;<span v-html="$getString('GLOBAL_RESTART')"></span><div class="button-overlay" @click="onRestart"></div></div>
        <div class="d-xs-inline-block fg-sma-fuchsia"><span class="icon icon-info"></span>&nbsp;<span v-html="$getString('GLOBAL_FURTHER_INFORMATION')"></span><div class="button-overlay" @click="openPopup"></div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StageSummaryAlt',
  props: {
    stage: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      ageGroup: null,
      symptoms: [],
      symptomStrings: [],
      answers: [],
      sliders: [],

      handlers: [],
    }
  },
  methods: {
    onSave() {
      this.$emit('action', { type: 'save' });
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_save`,
      } });
      this.$emit('action', { type: 'open-popup', data: {
        type: 'saved',
      }});
    },
    onRestart() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_restart`,
      } });
      this.$emit('action', { type: 'restart' });
    },
    openPopup() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_further_info`,
      } });
      this.$emit('action', { type: 'open-popup', data: {
        type: 'further',
      }});
    },

    getBody() {
      const answers = this.answers.join('%20%0D%0A');
      const sliders = this.sliders.join('%20%0D%0A');
      return `${answers}%20%0D%0A%20%0D%0A${sliders}`;
    },
    getAnswers(response) {
      let answers = [];
      response.answers.forEach(index => {
        answers.push(response.options(index));
      });
      return answers;
    },
    getResults() {
      const symptoms = this.$store.getters.dataKey('symptoms');
      const questions = this.$store.getters.dataKey('questions');
      const sliders = this.$store.getters.dataKey('sliders');

      this.symptoms = [];
      symptoms.forEach(symptomIndex => {
        const symptom = this.ageGroup.symptoms[symptomIndex];
        this.symptoms.push(symptom);
        this.symptomStrings.push(symptom.label);
      });

      this.answers = [];
      questions.forEach(question => {
        question.answers.forEach(answer => {
          this.answers.push(question.options[answer]);
        });
      });

      this.sliders = [];
      for (let key in sliders) {      
        this.sliders.push(sliders[key].string);
      }
    },
  },
  mounted() {
    this.ageGroup = this.$store.getters.ageGroup;
    this.$emit('action', { type: 'complete-progress' });

    this.getResults();
  },
}
</script>
